import BackgroundBluetoothScan from 'src/components/BackgroundBluetoothScan.svelte';
import { isActiveHomeShared } from 'src/helpers/houses/homes_helpers';
import { home_data } from 'src/stores/account/user';
import { isShowedDeviceBluetoothScan } from 'src/stores/session/alerts-onboarding';
import { app, bluetooth, location_state } from 'src/stores/session/native-bridge';
import type { ModalConfig } from 'src/types/Modals';
import { get } from 'svelte/store';
import { NoPremiumVoucherCheckRule } from './rules/NoPremiumVoucherRule';

export const BluetoothScanModalConfig: ModalConfig = {
	id: 'bluetoothScanState',
	component: BackgroundBluetoothScan,
	props: {
		priority: 20, // Lowest priority
		initialShow: true,
	},
	rules: [
		{
			check: () => {
				const homeData = get(home_data);
				return (
					get(app) &&
					!isActiveHomeShared() &&
					(homeData?.bgBtScan?.enable || homeData?.bgBtScan == undefined) &&
					get(bluetooth) == 'poweredOn' &&
					get(location_state) == 'authorised' &&
					!get(isShowedDeviceBluetoothScan)
				);
			},
			expected: true,
		},
		NoPremiumVoucherCheckRule,
	],
};
